// i18
export const MODULE_I18_PREFIX = 'luci.uncollected_funds' as const;
